export enum MobileSubMenu {
	Video = 'Video',
	Help = 'Help'
}
